var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-same-recommend"
  }, [_c('p', {
    staticClass: "same-title"
  }, [_vm._v("同类型推荐")]), _c('div', {
    staticClass: "same-recommend-list"
  }, [_vm._l(_vm.sameRecommendList, function (item, index) {
    return [_c('div', {
      key: index,
      staticClass: "list-item",
      class: {
        'only-three': _vm.sameRecommendList.length === 3
      },
      on: {
        "click": function click($event) {
          return _vm.goDetail(item);
        }
      }
    }, [_c('ycf-image', {
      staticClass: "picture-card",
      attrs: {
        "src": item.attachUrl + '?imageView2/1/w/220/h/220/interlace/1'
      }
    }), _c('div', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(item.hotelScenicName))]), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "sell-price"
    }, [_c('i', [_vm._v("￥")]), _c('span', [_vm._v(_vm._s(item.minPrice))])]), _vm.isPromoter === 1 ? _c('span', {
      staticClass: "commission"
    }, [_c('i', [_vm._v(_vm._s(_vm.isAPP ? "赚" : "省") + "￥")]), _c('span', [_vm._v(_vm._s(_vm._f("priceFormat")(item.maxComm)))])]) : _c('i', {
      staticClass: "origin-price"
    }, [_vm._v(_vm._s(item.price))])])], 1), index + 1 === _vm.sameRecommendList.length ? _c('div', {
      key: index,
      staticClass: "list-btn"
    }, [_c('div', {
      staticClass: "view-more",
      on: {
        "click": _vm.goHome
      }
    }, [_c('span', [_vm._v("查看更多")])]), _c('div', {
      staticClass: "right-blank"
    })]) : _vm._e()];
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };